<template>
  <d-list-group flush>
    <d-list-group-item class="p-3">
      <d-form @submit.prevent="save">
        <d-form-row class="customer">
          <!-- Nome -->
          <d-col md="9" class="form-group">
            <label>Empresa</label>
            <span class="form-control" readonly>{{ model.company_name }}</span>
          </d-col>

          <!-- Valid at -->
          <d-col md="3" class="form-group">
            <label>Plano criado em</label>
            <span class="form-control" readonly>{{ model.f_created_at }}</span>
          </d-col>
        </d-form-row>

        <a @click="showAddress = !showAddress" class="show-address">
          <span v-if="showAddress">Ocultar detalhes do cliente</span>
          <span v-else>Mostrar detalhes do cliente</span>
        </a>

        <transition name="fade">
          <div class="customer-container" v-if="showAddress">
            <d-form-row class="customer">
              <!-- Nome -->
              <d-col md="9" class="form-group">
                <label for="name">Nome do cliente</label>
                <span class="form-control" readonly>{{
                  model.customer.contact.name
                }}</span>
              </d-col>

              <!-- E-mail -->
              <d-col md="3" class="form-group">
                <label>E-mail</label>
                <span class="form-control" readonly>{{
                  model.customer.contact.email
                }}</span>
              </d-col>
            </d-form-row>

            <d-form-row class="customer">
              <!-- Document -->
              <d-col md="3" class="form-group">
                <label>CNPJ</label>
                <span class="form-control" readonly>{{
                  model.customer.document
                }}</span>
              </d-col>

              <!-- Phone -->
              <d-col md="3" class="form-group">
                <label>Telefone</label>
                <span class="form-control" readonly>{{
                  model.customer.phone
                }}</span>
              </d-col>

              <!-- Zipcode -->
              <d-col md="3" class="form-group">
                <label>Cep</label>
                <span class="form-control" readonly>{{
                  model.customer.addresses[0].zipcode
                }}</span>
              </d-col>
            </d-form-row>

            <d-form-row class="customer">
              <!-- Nome -->
              <d-col md="10" class="form-group">
                <label>Logradouro</label>
                <span class="form-control" readonly>{{ address[0] }}</span>
              </d-col>

              <!-- Number -->
              <d-col md="2" class="form-group">
                <label>Número</label>
                <span class="form-control" readonly>{{ address[1] }}</span>
              </d-col>
            </d-form-row>

            <d-form-row class="customer">
              <!-- Address2 -->
              <d-col md="3" class="form-group">
                <label>Complemento</label>
                <span class="form-control" readonly>{{
                  model.customer.addresses[0].address2
                }}</span>
              </d-col>

              <!-- District -->
              <d-col md="3" class="form-group">
                <label>Bairro</label>
                <span class="form-control" readonly>{{
                  model.customer.addresses[0].district
                }}</span>
              </d-col>

              <!-- City -->
              <d-col md="3" class="form-group">
                <label>Cidade</label>
                <span class="form-control" readonly>{{
                  model.customer.addresses[0].city
                }}</span>
              </d-col>

              <!-- State -->
              <d-col md="3" class="form-group">
                <label>Estado</label>
                <span class="form-control" readonly>{{
                  model.customer.addresses[0].state
                }}</span>
              </d-col>
            </d-form-row>
          </div>
        </transition>

        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="m-0">Agente: {{ model.chemical_agent }}</h5>
          <d-button
            v-if="model.type.slug === 'heat'"
            size="sm"
            class="btn-outline-light border"
            @click.prevent="openPdfModal"
          >
            <i class="fas fa-file-pdf mr-1 p-0" /> Importar dados via PDF
          </d-button>
        </div>

        <div class="table-sampler" v-if="model">
          <d-tabs card ref="tabs">
            <d-tab title="Caracterização" active class="border p-3">
              <sample-characterization :caracterization.sync="model" />
            </d-tab>
            <d-tab title="Memória de campo" class="border p-3">
              <component
                :is="memoryType(model.type.slug)"
                :memory.sync="model.memory_field"
              />
            </d-tab>
            <d-tab title="Resultado" class="border p-3">
              <component
                :is="resultType(model.type.slug)"
                :result.sync="model.result"
              />
            </d-tab>
            <d-tab title="Classificação de risco" class="border p-3">
              <component
                :is="classificationType(model.type.slug)"
                :classification.sync="model.risk_classification"
                :result.sync="model.result"
              />
            </d-tab>
            <d-tab title="Validação da medição" class="border p-3">
              <component
                :is="validationType(model.type.slug)"
                :validation.sync="model.validation"
              />
            </d-tab>
          </d-tabs>
        </div>
      </d-form>
      <import-pdf-modal />
    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import SampleService from '_services/rest/modules/sample';
import formatErrors from '_common/mixins/FormatErrors';
import { IMPORT_PDF_MODAL, MODEL, _CLEAR_FILES_, _IMPORT_PDF_SUCCESS_, _LOAD_MODEL_ } from './SampleModel';
import SampleCharacterization from './Tabs/SampleCharacterization.vue';
import SampleMemoryChemical from './Tabs/Memories/SampleMemoryChemical.vue';
import SampleResultChemical from './Tabs/Results/SampleResultChemical.vue';
import SampleValidationChemical from './Tabs/Validation/SampleValidationChemical.vue';
import SampleClassificationChemical from './Tabs/Classification/SampleClassificationChemical.vue';
import SampleMemoryNoise from './Tabs/Memories/SampleMemoryNoise.vue';
import SampleResultNoise from './Tabs/Results/SampleResultNoise.vue';
import SampleValidationNoise from './Tabs/Validation/SampleValidationNoise.vue';
import SampleClassificationNoise from './Tabs/Classification/SampleClassificationNoise.vue';
import SampleMemoryVibration from './Tabs/Memories/SampleMemoryVibration.vue';
import SampleResultVibration from './Tabs/Results/SampleResultVibration.vue';
import SampleValidationVibration from './Tabs/Validation/SampleValidationVibration.vue';
import SampleClassificationVibration from './Tabs/Classification/SampleClassificationVibration.vue';
import SampleMemoryHeat from './Tabs/Memories/SampleMemoryHeat.vue';
import SampleResultHeat from './Tabs/Results/SampleResultHeat.vue';
import SampleValidationHeat from './Tabs/Validation/SampleValidationHeat.vue';
import SampleClassificationHeat from './Tabs/Classification/SampleClassificationHeat.vue';
import ImportPdfModal from './Modal/ImportPdfModal.vue';

export default {
  name: 'sample-form',
  mixins: [formatErrors],
  components: {
    SampleMemoryChemical,
    SampleResultChemical,
    SampleCharacterization,
    SampleValidationChemical,
    SampleClassificationChemical,
    SampleMemoryNoise,
    SampleResultNoise,
    SampleValidationNoise,
    SampleClassificationNoise,
    SampleMemoryVibration,
    SampleResultVibration,
    SampleValidationVibration,
    SampleClassificationVibration,
    SampleMemoryHeat,
    SampleResultHeat,
    SampleValidationHeat,
    SampleClassificationHeat,
    ImportPdfModal,
  },
  data() {
    return {
      model: { ...MODEL },
      loading: false,
      showAddress: false,
    };
  },
  computed: {
    address() {
      if (this.model.customer.addresses[0].address !== null) {
        return this.model.customer.addresses[0].address.split(',');
      }
      return ['-', '-'];
    },
  },
  methods: {
    ...mapActions(['setToggle', 'setSample', 'activeAlert']),
    openPdfModal() {
      this.setToggle({ type: IMPORT_PDF_MODAL, bool: true });
    },
    memoryType(typeSlug) {
      const componentsTypes = {
        vibration: 'SampleMemoryVibration',
        chemical: 'SampleMemoryChemical',
        noise: 'SampleMemoryNoise',
        heat: 'SampleMemoryHeat',
      };
      return componentsTypes[typeSlug];
    },
    resultType(typeSlug) {
      const componentsTypes = {
        vibration: 'SampleResultVibration',
        chemical: 'SampleResultChemical',
        noise: 'SampleResultNoise',
        heat: 'SampleResultHeat',
      };
      return componentsTypes[typeSlug];
    },
    classificationType(typeSlug) {
      const componentsTypes = {
        vibration: 'SampleClassificationVibration',
        chemical: 'SampleClassificationChemical',
        noise: 'SampleClassificationNoise',
        heat: 'SampleClassificationHeat',
      };
      return componentsTypes[typeSlug];
    },
    validationType(typeSlug) {
      const componentsTypes = {
        vibration: 'SampleValidationVibration',
        chemical: 'SampleValidationChemical',
        noise: 'SampleValidationNoise',
        heat: 'SampleValidationHeat',
      };
      return componentsTypes[typeSlug];
    },
    getOptions() {
      if (!this.$store.state.sample.sampleType) {
        this.setToggle({ type: 'progress', bool: true });
        this.getSampleType().then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
      }
    },
    save() {
      SampleService.save(this.model)
        .then(response => {
          this.setSample(response);
          this.model = response;
          Events.$emit(_CLEAR_FILES_);
          this.activeAlert({
            message: 'Amostragem salva com sucesso',
            theme: 'success',
          });
        })
        .catch(this.showError);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = { ...newValue };
    });

    Events.$on(_IMPORT_PDF_SUCCESS_, mappedData => {
      const newModel = { ...this.model };

      if (mappedData.characterization) {
        Object.assign(newModel, mappedData.characterization);
      }

      const blocks = ['memory_field', 'risk_classification', 'result', 'validation'];

      blocks.forEach(key => {
        if (mappedData[key]) {
          newModel[key] = {
            ...(this.model[key] || {}),
            ...mappedData[key],
          };
        }
      });

      this.$set(this, 'model', newModel);
    });
  },
  beforeDestroy() {
    Events.$off(_IMPORT_PDF_SUCCESS_);
  },
};
</script>

<style lang="scss" scoped>
@import "~_scss/overrides";

.show-address {
  display: block;
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  span {
    color: $primary;
    cursor: pointer;
  }
}
.customer-container {
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  .customer {
    .form-group {
      label {
        margin: 0 0 5px;
      }
      margin-bottom: 7px;
    }
    ::v-deep(.form-control) {
      padding: 5px 10px;
      height: 33px;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fas {
  cursor: pointer;
  font-size: 15px;
  padding: 4px;
  &.fa-plus:hover {
    color: $green;
  }
  &.fa-minus:hover {
    color: $red;
  }
}
</style>
